import { render, staticRenderFns } from "./Cores.vue?vue&type=template&id=02c03c35&scoped=true"
import script from "./Cores.vue?vue&type=script&lang=js"
export * from "./Cores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c03c35",
  null
  
)

export default component.exports